import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { ModuleGroupPermissionService } from './module-group-permission.service';
import { EditModuleGroupPermissionComponent } from './edit-module-group-permission/edit-module-group-permission.component';
import { AddModuleGroupPermissionComponent } from './add-module-group-permission/add-module-group-permission.component';
import { ModuleGroupPermissionUpdatePayload } from './module-group-permission.interface';

import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-module-group-permission',
    templateUrl: './module-group-permission.component.html',
    styleUrls: ['./module-group-permission.component.scss'],
})
export class ModuleGroupPermissionComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    isLoading = true;

    parentValue: number = -1;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.app.settings.moduleGroupPermission
            .getModuleGroupPermissionsDT;

    showCard = false;
    activeValue: string = '-1';
    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    resetForm() {
        this.activeValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private moduleGroupPermissionService: ModuleGroupPermissionService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            responsive: true,
            pageLength: 25,
            searching: false,
            lengthMenu: [10, 25, 50, 100],
            language: environment.config.romanianLanguageDataTable,
            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.parent_id = this.parentValue;

                this.isLoading = true;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        console.log(resp);
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    searchable: false,
                },
                {
                    title: 'Părinte',
                    data: 'parent_name',
                    searchable: false,
                    sortable: false,
                },
                {
                    title: 'Denumire',
                    data: 'name',
                    searchable: false,
                },
                {
                    title: 'Slug',
                    data: 'slug',
                    searchable: false,
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    searchable: false,
                    className: 'all',

                    render: (data: any, type: any, row: any, met: any) => {
                        return `
            <div class="d-flex align-center justify-content-left">
						<button type="button" class="action-btn edit ms-1">
							<img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
						</button>
						<button type="button" class="action-btn delete ms-1">
							<img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
						</button>
            </div>
					`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any, index: number) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd ?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd ?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.administrative.grup_modules.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.administrative.grup_modules.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.delete(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            // dtInstance.destroy();
            // // Call the dtTrigger to rerender again
            // this.dtTrigger.next('');

            dtInstance.draw(resetPaging);
        });
    }

    delete(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // we do this because we need to have some control on activity
                this.deleteModuleAction(id);
            }
        });
    }

    deleteModuleAction(id: number) {
        this.isLoading = true;
        this.moduleGroupPermissionService.deleteModule(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Grup șters cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteModuleAction(id);
                    }
                });
            }
        );
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddModuleGroupPermissionComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Grup adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: ModuleGroupPermissionUpdatePayload) {
        const dialogRef = this.dialog.open(EditModuleGroupPermissionComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Grup actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
